import { render, staticRenderFns } from "./buttonLoader.vue?vue&type=template&id=bfb30778"
import script from "./buttonLoader.vue?vue&type=script&lang=js"
export * from "./buttonLoader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports